<template>
  <v-layout align-center fill-height justify-center>
    <v-flex>
      <v-img
        :width="imageWidth"
        src="/img/sad_emoticon.png"
        lazy-src="/img/sad_emoticon.png"
        class="mx-auto mb-4 opacity-2"
      >
        <v-layout
          slot="placeholder"
          fill-height
          align-center
          justify-center
          ma-0
        >
          <v-progress-circular indeterminate color="grey lighten-5" />
        </v-layout>
      </v-img>
      <div class="text-center">{{ message }}</div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    message: {
      type: [String],
      required: true,
      default: ''
    },
    imageWidth: {
      type: [String],
      required: false,
      default: '85px'
    }
  }
}
</script>

<style>
.opacity-2 {
  opacity: 0.2;
}
</style>
